import { useNavigate } from 'react-router-dom'
import { colors, font } from '../../design/tokens'
import { Titulo } from './comunes'
import { useAccesoMovil } from './accesoMovil'

// Clientes en el celular: dos accesos, igual que el menú CLIENTES del
// escritorio — Historia de clientes (cta cte) y Deudores.
const ACCESOS = [
  { icono: '📒', titulo: 'Historia de clientes', desc: 'Cuenta corriente — buscá un cliente y vela', to: '/m/historia' },
  { icono: '💰', titulo: 'Deudores', desc: 'Cuentas por cobrar — deuda neta por cliente', to: '/m/deudores' },
]

export default function MovilClientes() {
  const navigate = useNavigate()
  const { puede } = useAccesoMovil()

  return (
    <div>
      <Titulo>Clientes</Titulo>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        {ACCESOS.filter((a) => puede(a.to)).map((a) => (
          <button key={a.to} onClick={() => navigate(a.to)} style={acceso}>
            <span style={{ fontSize: 22, width: 30, textAlign: 'center', flexShrink: 0 }}>{a.icono}</span>
            <span style={{ flex: 1, textAlign: 'left', minWidth: 0 }}>
              <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 15, color: colors.text }}>{a.titulo}</span>
              <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>{a.desc}</span>
            </span>
            <span style={{ color: colors.textMeta, fontSize: 18, flexShrink: 0 }}>›</span>
          </button>
        ))}
      </div>
    </div>
  )
}

const acceso = {
  display: 'flex', alignItems: 'center', gap: 12, width: '100%', boxSizing: 'border-box',
  padding: '15px 14px', borderRadius: 14,
  border: `1px solid ${colors.border}`, background: colors.bg, cursor: 'pointer',
}
